import type { ScopePreset } from './types';

const RESOURCES = ['pessoa', 'obra', 'atividade', 'os'] as const;
const READ = RESOURCES.map((r) => `${r}:read`);
const CREATE = RESOURCES.map((r) => `${r}:create`);
const UPDATE = RESOURCES.map((r) => `${r}:update`);
const DELETE = RESOURCES.map((r) => `${r}:delete`);

export const PRESET_SCOPES: Record<Exclude<ScopePreset, 'custom'>, string[]> = {
  'read-only': [...READ],
  'read-create': [...READ, ...CREATE],
  'read-edit': [...READ, ...CREATE, ...UPDATE],
  full: [...READ, ...CREATE, ...UPDATE, ...DELETE],
};

export const PRESET_LABELS: Record<Exclude<ScopePreset, 'custom'>, string> = {
  'read-only': 'Somente leitura',
  'read-create': 'Leitura + criação',
  'read-edit': 'Leitura + edição (recomendado)',
  full: 'Acesso total',
};

export const PRESET_DESCRIPTIONS: Record<Exclude<ScopePreset, 'custom'>, string> = {
  'read-only': 'Apenas listar e ler registros. Ideal para dashboards e relatórios externos.',
  'read-create': 'Ler e criar novos registros. Não permite editar ou excluir.',
  'read-edit': 'Ler, criar e editar. Não permite excluir. Padrão para integrações de escrita.',
  full: 'Acesso total — incluindo exclusão. Use apenas se a integração precisar mesmo.',
};

export const ALL_SCOPES: readonly string[] = [...READ, ...CREATE, ...UPDATE, ...DELETE];
